import ApplicationStyles from 'app/styles/ApplicationStyles';
import { Colors, Metrics } from 'app/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
	},
    appBarSpacer: theme.mixins.toolbar,
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    button: {
        marginLeft: 8,
    },
	content: {
		flexGrow: 1,
        paddingBottom: 8,
		height: '100vh',
		overflow: 'auto',
	},
    tabContainer: {
        'marginLeft': Metrics.baseMargin,
        'marginRight': Metrics.baseMargin,
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
    },
    tab: {
        flex: 1,
        display: 'flex',
        flexDirection:'column',
        height: '100%',
    },
    fill: {
        height: 20,
        width: 20,
        borderRadius: 20,
        color: Colors.primary,
        backgroundColor: Colors.primary
    },
    empty: {
        borderRadius: 20,
        height: 20,
        width: 20,
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: Colors.primary,
    },
    deleteIcon: {
        color: Colors.red,
        fontSize: 20,
    },
    editIcon: {
        color: Colors.primary,
        fontSize: 20,
    },
}));

export const styles = ({
    ...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
	titleBox: {
        ...ApplicationStyles.margins.baseHorizontalMargin,
        ...ApplicationStyles.margins.smallVerticalMargin
    },
    inputSelect:{
    	width: '100%',
    	paddingRight: 8,
        paddingBottom: 10,
    }
})

